import React, { useState } from "react";
import { Drawer, Space, Button, Typography, Select, Alert, Input, Upload,Spin } from "antd";
import PhoneInput from "react-phone-input-2";
import { UploadOutlined } from '@ant-design/icons';
const AddContactDoalog = (props) => {
    const { Title, Text } = Typography
    const { Option } = Select;
    const [addMethod, setMethod] = useState('Manual')
    const info = <Text>First <b><a href = {props?.templateFile} target='_blank' download> Download the Sample File</a></b> and add your contact then import to Sehahub</Text>
    const onSelectMethod = (data) => {
        console.log(data)
        setMethod(data)

    }
    const fileUpload = (value) => {
        console.log(value)
        const { onSuccess, onError, file, onProgress } = value
        onSuccess("ok");

    }
    const message = `Fisrt`
    return <Drawer
        title="Add User"
        placement='right'
        width={500}
        maskClosable={false}
        onClose={() => {
            props.approveUser(false)
            props?.onCancel()
        }}
        visible={props.visible}
        extra={
            <Space>
                <Button onClick={() => {
                    props.approveUser(false)
                    props?.onCancel()
                }}>Cancel</Button>
                <Button
                 loading={props?.mutation?.isLoading || props?.editData?.isLoading}
                 type="primary" onClick={() => {
                     if(props?.mode == 'save'){
                    props?.onSaveContact()
                     }
                     else{
                         props?.onSaveEditContact()
                     }
                }}>
                   {props?.mode == 'save' ? 'Save' : 'Edit'}
                </Button>
            </Space>
        }
    >
        <Select
            style={{ width: '50%', marginTop: '10px' }}
            showSearch
            defaultValue={addMethod}
            placeholder="Select a Method"
            optionFilterProp="children"
            onChange={onSelectMethod}
        >
            <Option value="Manual">Add User Manually</Option>
            <Option value="CSV">Import from CSV</Option>
        </Select>

        <div className="importUserContiner">
            {addMethod == 'Manual' ?
                props?.addUser?.fields?.map(item => {
                    if (item?.type == "Text") {
                        return <div className="singleElement">
                            <Text className="userTitle">{item?.Label}<Text type="danger">*</Text></Text>
                            <Input className="textBox" type={item?.type} onChange={(event) => {
                                props?.addContact(item?.id, event?.target?.value)
                            }}
                            value={props?.contactDetail?.[item.id]}
                            
                            ></Input>
                            {

                            }
                        </div>
                    }
                    else {
                        return <div className="singleElement">
                            <Text className="userTitle" >{item?.Label}<Text type="danger">*</Text></Text>
                            <PhoneInput
                                value={props?.contactDetail?.[item.id]}
                                className="textBox"
                                country='pk'
                                id="regPhone"
                                onChange={(Phone) => {
                                    props?.addContact(item?.id, `+${Phone}`)
                                }
                                }

                            />
                        </div>
                    }
                })
                : <div className="uploadContainer">
                <Alert message={info} type="info" showIcon closable />
                <Upload
                   className="csvUpload"
                    percent={86}
                    progress={{
                        strokeColor: {
                            "0%": "#108ee9",
                            "100%": "#87d068",
                        },
                    }}
                    id='userUpload'
                    accept="pdf"
                    customRequest={(file) => {
                        props?.readFile(file?.file)
                        fileUpload(file);
                    }}
                    onRemove={() => {
                    }}
                    maxCount={1}
                >
                    <Button icon={<UploadOutlined />}>Select CSV File <Text type="danger">*</Text></Button>
                </Upload>
                {props?.importUser?.isLoading && <Spin></Spin>}
                </div>
            }


        </div>
    </Drawer>
}

export default AddContactDoalog